import { render, staticRenderFns } from "./PersonalidadJuridicaView.vue?vue&type=template&id=2e514301&"
import script from "./PersonalidadJuridicaView.vue?vue&type=script&lang=ts&"
export * from "./PersonalidadJuridicaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports